import DashboardLayout from "@/views/Layout/DashboardLayout.vue";

import AdminLayout from "@/views/Layout/AdminLayout.vue";

import AuthLayout from "@/views/Layout/AuthLayout.vue";
import NotFound from "@/views/GeneralViews/NotFoundPage.vue";

// Dashboard pages
const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard.vue");

const AdminIndex = () =>
  import(/* webpackChunkName: "AdminIndex" */ "@/views/Pages/Admin/Index.vue");
const Gateways = () =>
  import(
    /* webpackChunkName: "AdminIndex" */ "@/views/Pages/Admin/Gateways.vue"
  );

const Gateway = () =>
  import(
    /* webpackChunkName: "AdminIndex" */ "@/views/Pages/Admin/Gateway.vue"
  );

const Systems = () =>
  import(/* webpackChunkName: "Systems" */ "@/views/Pages/Admin/Systems.vue");

const System = () =>
  import(/* webpackChunkName: "Systems" */ "@/views/Pages/Admin/System.vue");

const Companies = () =>
  import(
    /* webpackChunkName: "companies" */ "@/views/Pages/Admin/Companies.vue"
  );

const SysAdmin = () =>
  import(/* webpackChunkName: "sysAdmi" */ "@/views/Pages/Admin/SysAdmin.vue");

const NotificationManagement = () =>
  import(
    /* webpackChunkName: "notificationManagement" */ "@/views/Pages/Admin/NotificationManagement.vue"
  );

const P = () => import(/* webpackChunkName: "p" */ "@/views/Pages/P.vue");

const AdminUsers = () =>
  import(
    /* webpackChunkName: "adminUsers" */ "@/views/Pages/Admin/AdminUsers.vue"
  );

const AdminUser = () =>
  import(
    /* webpackChunkName: "adminUser" */ "@/views/Pages/Admin/AdminUser.vue"
  );

const Company = () =>
  import(/* webpackChunkName: "company" */ "@/views/Pages/Admin/Company.vue");

const NewCompany = () =>
  import(
    /* webpackChunkName: "company" */ "@/views/Pages/Admin/NewCompany.vue"
  );

const Login = () =>
  import(/* webpackChunkName: "login" */ "@/views/Pages/Login.vue");
const ResetPassword = () =>
  import(
    /* webpackChunkName: "resetpassword" */ "@/views/Pages/ResetPassword.vue"
  );
const SetPassword = () =>
  import(/* webpackChunkName: "setpassword" */ "@/views/Pages/SetPassword.vue");

const Customer = () =>
  import(/* webpackChunkName: "customer" */ "@/views/Pages/Customer.vue");

const PaymentPlans = () =>
  import(
    /* webpackChunkName: "paymentplans" */ "@/views/Pages/PaymentPlans.vue"
  );

const Transactions = () =>
  import(
    /* webpackChunkName: "transactions" */ "@/views/Pages/Transactions.vue"
  );

const Profile = () =>
  import(/* webpackChunkName: "profile" */ "@/views/Pages/Profile.vue");

const CompanyProfile = () =>
  import(
    /* webpackChunkName: "companyprofile" */ "@/views/Pages/CompanyProfile.vue"
  );

const Notifications = () =>
  import(
    /* webpackChunkName: "notifications" */ "@/views/Pages/Notifications.vue"
  );

const CustomerMembershipBillings = () =>
  import(
    /* webpackChunkName: "customerMembershipBillings" */ "@/views/Pages/CustomerMembershipBillings.vue"
  );

const ManageMembership = () =>
  import(
    /* webpackChunkName: "manageMembership" */ "@/views/Pages/ManageMembership.vue"
  );

const ManageProcedures = () =>
  import(
    /* webpackChunkName: "manageMembership" */ "@/views/Pages/ManageProcedures.vue"
  );

const ApptSchedule = () =>
  import(
    /* webpackChunkName: "apptSchedule" */ "@/views/Pages/Appts/Schedule.vue"
  );

const ApptList = () =>
  import(/* webpackChunkName: "apptList" */ "@/views/Pages/Appts/ApptList.vue");

const Schedule = () =>
  import(/* webpackChunkName: "schedule" */ "@/views/Pages/Schedule.vue");

let customerMenu = {
  path: "/Customer/:id",
  component: DashboardLayout,
  name: "Customer",
  children: [
    {
      path: "",
      name: "CustomerIndex",
      component: Customer,
    },
  ],
};

let scheduleMenu = {
  path: "/manageSchedule",
  component: DashboardLayout,
  name: "Schedule",
  children: [
    {
      path: "",
      name: "ScheduleIndex",
      component: Schedule,
    },
  ],
};

let manageMembership = {
  path: "/managemembership",
  component: DashboardLayout,
  name: "ManageMembership",
  children: [
    {
      path: "",
      component: ManageMembership,
    },
  ],
};

let apptsScheduleMenu = {
  path: "/appts/schedule",
  component: DashboardLayout,
  name: "ApptsSchedule",
  children: [
    {
      path: "",
      component: ApptSchedule,
    },
  ],
};

let apptsListMenu = {
  path: "/appts",
  component: DashboardLayout,
  name: "appts",
  children: [
    {
      path: "",
      component: ApptList,
    },
  ],
};
let manageProceduresMenu = {
  path: "/manageProcedures",
  component: DashboardLayout,
  name: "ManageProcedures",
  children: [
    {
      path: "",
      component: ManageProcedures,
    },
  ],
};

let transactionsMenu = {
  path: "/transactions",
  component: DashboardLayout,
  name: "Transactions",
  children: [
    {
      path: "",
      name: "View",
      component: Transactions,
    },
  ],
};

let textToPaymenu = {
  path: "/notifications",
  component: DashboardLayout,
  name: "Notifications",
  children: [
    {
      path: "",
      name: "Notifications",
      component: Notifications,
    },
  ],
};

let customerMembershipBillings = {
  path: "/customermembershipbillings",
  component: DashboardLayout,
  name: "CustomerMembershipBillings",
  children: [
    {
      path: "",
      name: "CustomerMembershipBillings",
      component: CustomerMembershipBillings,
    },
  ],
};

let paymentPlansMenu = {
  path: "/paymentplans",
  component: DashboardLayout,
  name: "PaymentPlans",
  children: [
    {
      path: "",
      name: "PaymentPlansList",
      component: PaymentPlans,
    },
  ],
};

let profileMenu = {
  path: "/profile",
  component: DashboardLayout,
  name: "Profile",
  children: [
    {
      path: "",
      name: "ProfileIndex",
      component: Profile,
    },
  ],
};

let companyProfileMenu = {
  path: "/companyProfile",
  component: DashboardLayout,
  name: "CompanyProfile",
  children: [
    {
      path: "",
      name: "CompanyProfile",
      component: CompanyProfile,
    },
  ],
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  meta: {
    noAuth: true,
  },
  children: [
    {
      path: "/Login",
      name: "Login",
      component: Login,
      meta: {
        noAuth: true,
      },
    },

    {
      path: "/Reset",
      name: "Reset",
      component: ResetPassword,
      meta: {
        noAuth: true,
      },
    },
    {
      path: "/SetPassword/:id",
      name: "SetPassword",
      component: SetPassword,
      meta: {
        noAuth: true,
      },
    },
    { path: "*", component: NotFound },
  ],
};

const routes = [
  {
    path: "/",
    redirect: "/Login",
    name: "Login",
  },

  profileMenu,
  customerMenu,

  paymentPlansMenu,
  transactionsMenu,

  customerMembershipBillings,
  scheduleMenu,
  apptsListMenu,
  manageProceduresMenu,
  companyProfileMenu,
  textToPaymenu,
  apptsScheduleMenu,
  manageMembership,
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    name: "Dashboard layout",

    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
      },
      {
        path: "theme",
        component: () => import("@/views/Pages/Theme.vue"),
        name: "theme",
      },
    ],
  },

  {
    path: "/admin",
    component: AdminLayout,
    meta: {
      admin: true,
    },
    name: "Admin layout",
    children: [
      {
        path: "",
        name: "AdminIndex",
        component: AdminIndex,
      },
      {
        path: "adminusers",
        name: "AdminUsers",
        component: AdminUsers,
      },
      {
        path: "adminuser/:id?",
        name: "AdminUser",
        component: AdminUser,
      },
      {
        path: "companies",
        name: "Companies",
        component: Companies,
      },
      {
        path: "company/:id?",
        name: "Company",
        component: Company,
      },

      {
        path: "newCompany",
        name: "NewCompany",
        component: NewCompany,
      },

      {
        path: "sysadmin",
        name: "SysAdmin",
        component: SysAdmin,
      },
      {
        path: "notificationManagement",
        name: "NotificationManagement",
        component: NotificationManagement,
      },

      {
        path: "sysadmin",
        name: "sysadmin",
        component: SysAdmin,
      },
      {
        path: "systems",
        name: "systems",
        component: Systems,
      },
      {
        path: "system/:id?",
        name: "system",
        component: System,
      },
    ],
  },
  authPages,
];

export default routes;
